import React, { Fragment } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SectionTitle from '../Title'
import './style.scss'

// images
import portfolio1 from '../../images/about/1.jpg'
import portfolio3 from '../../images/about/4.jpeg'
import portfolio4 from '../../images/about/3.jpeg'
import portfolio5 from '../../images/about/4.png'
import portfolio7 from '../../images/studies/ayushi_lawyer.png'
import nuAhmed from '../../images/team/nu-ahmed.jpg'
import anilYadav from '../../images/team/anil-yadav.jpg'

const teams = [
    {
        image: portfolio1, name: 'Advocate Aman Verma', level: 'Advocate High Court & Supreme Court', id: "aman-verma", socialMedia: [

        ]
    },
    {
        image: portfolio5, name: 'Advocate Anoop Prakash Avasthi', level: 'Advocate On Record (AOR)', id: "avasthi", socialMedia: [

        ]
    },
    {
        image: nuAhmed, name: 'Advocate NU Ahmed', level: 'Advocate', id: "nu-ahmed", objectPosition: 'center top', socialMedia: [

        ]
    },
    {
        image: portfolio7, name: 'Advocate Ayushi Mehrotra', level: 'Advocate', id: "ayushi-mehrotra", socialMedia: [

        ]
    },
    {
        image: portfolio3, name: 'Advocate Utkarsh Bhatt', level: 'Associate', id: "utkarsh-bhatt", socialMedia: [

        ]
    },
    
    {
        image: portfolio4, name: 'Advocate Ratnesh', level: 'Associate', id: "ratnesh", socialMedia: [

        ]
    },
    {
        image: anilYadav, name: 'Advocate Anil Yadav', level: 'Advocate', id: "anil-yadav", objectPosition: 'center top', socialMedia: [

        ]
    }
];

// const teams = [
//     {
//         name: 'Alecgander Harry', level: 'Business Lawyer', image: teamMember1, socialMedia: [
//             'facebook', 'twitter', 'linkedin'
//         ]
//     },
//     {
//         name: 'Lily Watson', level: 'Family Lawyer', image: teamMember2, socialMedia: [
//             'facebook', 'twitter', 'linkedin'
//         ]
//     },
//     {
//         name: 'Willam Stephen', level: 'Criminal Lawyer', image: teamMember3, socialMedia: [
//             'facebook', 'twitter', 'linkedin'
//         ]
//     },
//     {
//         name: 'Eshan Golly', level: 'Business Lawyer', image: teamMember4, socialMedia: [
//             'facebook', 'twitter', 'linkedin'
//         ]
//     },
//     {
//         name: 'Daniel Dambeldor', level: 'Family Lawyer', image: teamMember5, socialMedia: [
//             'facebook', 'twitter', 'linkedin'
//         ]
//     },
//     {
//         name: 'Darcy Alec', level: 'Criminal Lawyer', image: teamMember6, socialMedia: [
//             'facebook', 'twitter', 'linkedin'
//         ]
//     },
// ]

const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};
const TeamMember = ({ className, title, subTitle, description, slider, noGutters }) => {
    return (
        <div className={className}>
            <div className="container">
                <div className={!noGutters ? 'row' : 'row no-gutters'}>
                    <div className="col-12">
                        <SectionTitle
                            title={title}
                            subTitle={subTitle}
                            description={description}
                        />
                    </div>
                    {slider ? (
                        <div className="col-12">
                            <Slider className="teamSlideArea" {...settings}>
                                {teams.map((team, i) => (
                                    <div key={i} className="teamWrapper">
                                        <div className="teamImage">
                                            <img loading="lazy" decoding="async" src={team.image} alt="" style={team.objectPosition ? { objectPosition: team.objectPosition } : undefined} />
                                        </div>
                                        <div className="teamContent">
                                            <h3>{team.name}</h3>
                                            <span>{team.level}</span>
                                            <ul>
                                                {team.socialMedia.map(social => (
                                                    <li key={social}><a href="/" aria-label={social}><i className={`fa fa-${social}`} aria-hidden="true"></i></a></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    ) : (
                        <Fragment>
                            {teams.map((team, i) => (
                                <div key={i} className="col-lg-4 col-md-6 col-12 mb-4">
                                    <div className="teamWrapper">
                                        <div className="teamImage">
                                            <img loading="lazy" decoding="async" src={team.image} alt="" style={team.objectPosition ? { objectPosition: team.objectPosition } : undefined} />
                                        </div>
                                        <div className="teamContent">
                                            <h3>{team.name}</h3>
                                            <span>{team.level}</span>
                                            <ul>
                                                {team.socialMedia.map(social => (
                                                    <li key={social}><a href="/" aria-label={social}><i className={`fa fa-${social}`} aria-hidden="true"></i></a></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    )
}
export default TeamMember